export const NEWEST = 'updated_at';
export const MOST_POPULAR = 'popularity';

export const CLASS_NAME = 'Forums::Discussion';

export const QUICK_FILTERS = [
  {
    label: s__('Forum|Updated recently'),
    name: NEWEST,
    isChecked: true,
    uncheck: [MOST_POPULAR],
    check: [],
  },
  {
    label: s__('Forum|Most popular'),
    name: MOST_POPULAR,
    isChecked: false,
    uncheck: [NEWEST],
    check: [],
  },
];

export const DEFAULT_FILTER_SETTINGS = [
  {
    id: MOST_POPULAR,
    value: MOST_POPULAR,
    name: MOST_POPULAR,
    label: s__('Forum|Most popular'),
  },
  {
    id: NEWEST,
    value: NEWEST,
    name: NEWEST,
    label: s__('Forum|Updated recently'),
  },
];

export const PAGE_SIZE = 10;
